const ACCESS_DENIED_RE = /нет доступа к скиллу\s*\/?([a-z][a-z0-9_]*)/i;

export function parseSkillAccessDenied(detail: string): { skillCode: string | null } | null {
  const m = detail.match(ACCESS_DENIED_RE);
  if (!m) return null;
  return { skillCode: m[1] ?? null };
}
